import { selectIsFetching } from './state/search/selector'

export default {
    action: {},
    selector: {
        selectIsFetching: (state) => {
            return selectIsFetching(state)
        },
    },
}


// WEBPACK FOOTER //
// ./src/modules/voucher/index.js